import React, { useState, useEffect } from "react";
import HomePresenter from "./HomePresenter";

import { useQuery, gql } from "@apollo/client";

import { useParams } from "react-router-dom";
import {
  useFontList,
  useFontListUpdate,
  useFontCartList,
} from "contexts/font.Context";

import RouteChangeTracker from "../../components/RouteChangeTracker"

const GET_FONTLIST = gql`
  query getFontList($category: String!, $keyword: String!, $sortType: String!) {
    fontList(category: $category, keyword: $keyword, sortType: $sortType) {
      idx
      familyname
      types
      file
      webfontname
      kor_names
      is_new
      fonts
      family_type
      cnt
    }
    categoryDepth(category: $category) {
      deco_mat
      headline
      title
      body
      hanja
      char_num
    }
  }
`;

const Container = () => {
  //파라미터에 추출
  // all
  // gothic,
  let { category, search, sort } = useParams();
  // let { pathname } = useLocation();

  const query = category ? category : "";

  // id = id ? id : "";
  search = search ? search : "";
  category = category ? category : "";
  sort = { label: "이름순", value: "name", col: "" };

  // 검색 키워드
  // 링크로 페이지가 이동해서 오면 useLocation 이용해야되
  // const getCategory = (path) => path.split("/")[1];
  // const depth1 = getCategory(pathname);

  // console.log(depth1, category, id, search);

  const { mainFontList: fontList } = useFontList();
  const { cartFontList: cartList } = useFontCartList();
  const { saveMainFontList } = useFontListUpdate();
  const [position, setPosition] = useState(category);
  const [sortType, setSortType] = useState(sort);

  const col = sortType?.col;

  const { data, loading } = useQuery(GET_FONTLIST, {
    variables: { category: query, keyword: search, sortType: col },
  });


  useEffect(() => {
    if (!loading) {
      if (data?.fontList !== null) {
        saveMainFontList(data.fontList);
      }
    }
  });



  if (position !== category) {
    window.scrollTo(0, 0);
    setPosition(category);
  }



  //google analytice route tracking
  RouteChangeTracker()


  return (
    <>
      <HomePresenter
        data={fontList}
        loading={loading}
        sortType={sortType}
        changeSort={setSortType}
      />
    </>
  )


};

export default Container;
